import { Component } from '@angular/core';
import { NavController, NavParams, ViewController } from 'ionic-angular';

@Component({
  selector: 'page-event-reserve-view',
  templateUrl: 'event-reserve-view.html',
})
export class EventReserveView {

  client: any;
  event: any;
  reserveData: any;

  constructor(public navCtrl: NavController, public params: NavParams, public view: ViewController) {
    this.client = this.params.get('client');
    this.event = this.params.get('event');
    this.reserveData = this.params.get('reserveData');
  }

  close() {
    this.view.dismiss();
  }

  share() {

  }
}
// end file



// WEBPACK FOOTER //
// ./src/pages/event-reserve-view/event-reserve-view.ts